<template>
  <div class="language-page">
    <div class="language-list">
      <div class="language-list__header">
        <p
          class="language-list-header__title"
          :style="{ color: $store.registratorCaptionColor }"
        >
          <!-- {{ 'registrator_label_choose_language' | translate }} -->
        </p>
      </div>

      <div class="language-list__languages">
        <div
          v-for="language in languages"
          :key="language.tag"
          class="language-list__item"
          :style="{ backgroundColor: $store.registratorBackgroundBtnColor }"
          @click="selectLanguage(language)"
        >
          <p
            class="language-item__name"
            :style="{ color: $store.registratorTextBtn }"
          >
            {{ language.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguagePage',
  computed: {
    languages() {
      return this.$store.deviceStartData.languages.filter(
        (language) => language.is_enabled,
      );
    }
  },
  methods: {
    selectLanguage(language) {
      this.$store.currentLanguage = language;
      this.$languageService.changeLanguage(language.tag);
      this.$emit('languageSelected');
    }
  }
};
</script>

<style lang="scss" scoped>
.language-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.language-list__header {
  height: 60px;
}

.language-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 1;
  align-content: baseline;

  &__header {
    width: 100%;
    display: flex;
    align-items: center;
  }

  &__languages {
    max-width: 100vw;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    align-content: center;
    align-items: center;
    justify-content: center;
    gap: 0.78125vh;
    margin-top: 20px;
  }

  &-header__title {
    width: 100%;
    font-weight: 600;
    font-size: 2.9296875vh;
    text-align: center;
    line-height: 1.2;
    margin: 2.34375vh;
  }

  &__item {
    width: calc(50% - 0.78125vh * 2);
    height: 12.5vh;
    min-height: 70px;
    margin: 0.68125vh;
    padding: 0 1.875vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074),
      0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
}

.language-item {
  &__name {
    font-size: max(2.34375vw, 30px);
    text-transform: uppercase;
  }
}


@media screen and (max-width: 645px) {
  .language-list {
    &__item {
      height: 60px;
      width: 90%;
    }
  }
  .language-item {
    &__name {
      font-size: 20px;
    }
  }
}
</style>
